import { mapParamsBySchema } from '../../../../util';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { M_PER_NEW_Schema } from './M_PER_NEW_Schema';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';
import Global from '../../../../Services/Common/Global';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_PER_NEW_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Permit', 'getPerNewR1', params.SearchType, params.WorkDate, params.DepCd],
    queryFn: () => apiRequest('post', Global.urls.Permit.getPerNewR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(M_PER_NEW_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.Permit.getPerCustomR4, params);
  }, successOptions);
};

export const useSearch3 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_PER_NEW_Schema.mapper.search3);

  const query = useQuery({
    queryKey: ['Permit', 'getPerNewR5', params],
    queryFn: () => apiRequest('post', Global.urls.Permit.getPerNewR5, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
export const useSearch4 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_PER_NEW_Schema.mapper.search4);

  const query = useQuery({
    queryKey: ['Permit', 'getPerNewR4', params],
    queryFn: () => apiRequest('post', Global.urls.Permit.getPerNewR4, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
export const useSave1 = () =>
  useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(M_PER_NEW_Schema.mapper.save1, context);

    return apiRequest('post1', Global.urls.Permit.savePerNewU1, payload);
  });

export const useSave2 = () =>
  useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(M_PER_NEW_Schema.mapper.save2, context);
    return apiRequest('post1', Global.urls.Permit.savePerCustomU2, payload);
  });
